import moment from "moment-timezone";
import { CancelActionType } from "./constants";
import { HCF_USER_EVENTS } from "../../constants/firebaseEvents";
import { logEvent } from "@src/appV2/lib/analytics";
import { getWorkerTrip, WorkerEtaForbiddenError } from "../../api/workerEta";
import { UrgentShiftCancelEventShift } from "./index";

type CancelEventAttributes = {
  action: CancelActionType;
  etaInMins?: number;
};

export async function sendUrgentShiftCancelEvent(
  shift: UrgentShiftCancelEventShift,
  action: CancelActionType
) {
  let etaResponse;
  try {
    etaResponse = await getWorkerTrip({
      shiftId: shift._id,
      workerId: shift.agentId ?? "",
      workplaceId: shift.facilityId,
    });
  } catch (error) {
    if (error instanceof WorkerEtaForbiddenError) {
      etaResponse = undefined;
    } else {
      throw error;
    }
  }
  const eventAttributes: CancelEventAttributes = {
    action,
  };

  if (etaResponse?.currentEtaDuration) {
    const currentShiftTime = moment.tz(shift.start, shift.facility?.tmz);
    const eta = moment().add(etaResponse?.currentEtaDuration, "minutes").tz(shift.facility?.tmz);
    const etaInMins = eta.diff(currentShiftTime, "minutes", true);
    if (etaInMins >= 0) {
      eventAttributes.etaInMins = etaInMins;
    }
  }

  logEvent(HCF_USER_EVENTS.URGENT_SHIFT_CANCELLED, eventAttributes);
}
